/** Site footer copy. Prefix: "foot." */
export const footer = {
  en: {
    "foot.blurb1": "TruWe creates science-backed wellness products designed for performance, balance, recovery, and longevity.",
    "foot.blurb2": "Clinical precision. Functional ingredients. Modern wellness.",
    "foot.col.shop": "Shop",
    "foot.link.allProducts": "All products",
    "foot.link.truweKids": "TruWe Kids",
    "foot.link.findRoutine": "Find your routine",
    "foot.link.dietPlan": "Free diet plan",
    "foot.link.ingredients": "Ingredients & research",
    "foot.col.shopByNeed": "Shop by need",
    "foot.link.magnesium": "Magnesium supplements",
    "foot.link.sleepRecovery": "Sleep & recovery",
    "foot.link.inositol": "Inositol supplements",
    "foot.link.pcos": "PCOS nutrition",
    "foot.link.liverGut": "Liver & gut support",
    "foot.link.kidsNutrition": "Kids nutrition",
    "foot.col.company": "Company",
    "foot.link.about": "About",
    "foot.link.contact": "Contact",
    "foot.link.loyalty": "Loyalty program",
    "foot.link.becomeAffiliate": "Become an affiliate",
    "foot.link.affiliateLogin": "Affiliate login",
    "foot.col.support": "Support",
    "foot.link.bulkEnquiry": "Bulk enquiry / channel partner",
    "foot.link.helpContact": "Help & contact",
    "foot.link.shippingPolicy": "Shipping policy",
    "foot.link.returnExchange": "Return & exchange",
    "foot.link.refundPolicy": "Refund policy",
    "foot.link.privacyPolicy": "Privacy policy",
    "foot.link.termsOfService": "Terms of service",
    "foot.copyright": "© {year} OMKARA NUTRACEUTICALS PRIVATE LIMITED. Brand Owner of TruWe.",
    "foot.manufactured": "Manufactured in a USFDA, GMP & ISO certified facility.",
  },
} as const;
